import Card from "../../../../componentsNew/Card";
import Typography from "../../../../componentsNew/Typography";

export function CardDash({ children, titulo, className, id, componenteLateral, componenteTitulo }) {

    return (
        <Card className={`p-4 ${className}`} id={id}>
            <div className="flex justify-between">
                <div className="flex items-center content-center">
                    {titulo && <Typography component="h4-card-dash">{titulo}</Typography>}
                    {componenteTitulo}
                </div>

                {componenteLateral}
            </div>

            {children}
        </Card>
    )
}
